import { RouteName } from '@/router'

/** enrolled = 재원생 / guest = 비재원생(입학고사 응시 대상) */
export const LESSON_STUDENT_TYPE = {
  enrolled: 'enrolled',
  guest: 'guest',
} as const

export type LessonStudentType = (typeof LESSON_STUDENT_TYPE)[keyof typeof LESSON_STUDENT_TYPE]

const GUEST_PATH_PREFIX = RouteName.lessonGuestEntranceTest // '/lesson/guest/entrance-test'

export const getLessonStudentType = (pathname: string): LessonStudentType =>
  pathname.startsWith(GUEST_PATH_PREFIX) ? LESSON_STUDENT_TYPE.guest : LESSON_STUDENT_TYPE.enrolled

export const getLessonStudentTypeNavTarget = (
  studentType: LessonStudentType,
): ValueOf<typeof RouteName> =>
  studentType === LESSON_STUDENT_TYPE.guest
    ? RouteName.lessonGuestEntranceTestWorksheet
    : RouteName.lessonWorksheet
